import axios from "axios";
import { useEffect } from "react";

const { createSlice } = require("@reduxjs/toolkit");

export const initialState = {
  users: [],
};

const usersSlice = createSlice({
  name: "usersSuccess",
  initialState,

  reducers: {
    usersSuccess: (state, { payload }) => {
      //   console.log({ payload });
      state.users = payload;
    },
  },
});

export const { usersSuccess } = usersSlice.actions;
export default usersSlice.reducer;
